import Model from "../Model";
import ValidatableObject from "../validation/ValidatableObject";
import { IDropdownOption } from "./DropdownOption";

export interface TAttribute {
  code: string;
  attributeName: string;
  valid: boolean;
  description: string;
  type: string;
  sqlValidation: string;
  methodValidation: string;
  options?: IDropdownOption[];
}

export interface IAttribute extends TAttribute {}

const Attribute = Model(
  (model: TAttribute): IAttribute => {
    const _attribute: TAttribute = Object.assign({}, model);

    let create = (attribute: IAttribute): IAttribute => {
      let obj = ValidatableObject(attribute);
      return obj;
    };

    let attribute = {
      get code() {
        return _attribute.code;
      },
      set code(value) {
        _attribute.code = value;
      },
      get attributeName() {
        return _attribute.attributeName;
      },
      set attributeName(value) {
        _attribute.attributeName = value;
      },
      get valid() {
        return _attribute.valid;
      },
      set valid(value) {
        _attribute.valid = value;
      },
      get description() {
        return _attribute.description;
      },
      set description(value) {
        _attribute.description = value;
      },
      get type() {
        return _attribute.type;
      },
      set type(value) {
        _attribute.type = value;
      },
      get sqlValidation() {
        return _attribute.sqlValidation;
      },
      set sqlValidation(value) {
        _attribute.sqlValidation = value;
      },
      get methodValidation() {
        return _attribute.methodValidation;
      },
      set methodValidation(value) {
        _attribute.methodValidation = value;
      },
      get options() {
        return _attribute.options;
      },
      set options(value) {
        _attribute.options = value;
      }
    };

    return create(attribute);
  }
);

export default Attribute;
